// AuditoriaCotizacionTabXL - Sprint 44 Fase 3 Vista 4.
// Grid auditoria XL con 7 filas. Tokens + dark.
import { useEffect } from 'react';
import { ensureKeyframes, injectCSS } from '../../../design/motion';

const CSS_ID = 'xl-audit-cot-css';
const CSS = `
.xl-audit {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  font-family: var(--xl-font-sans);
}
@media (max-width: 720px) { .xl-audit { grid-template-columns: 1fr } }
.xl-audit__card {
  background: var(--xl-color-surface-alt);
  border: 1px solid var(--xl-color-border);
  border-radius: var(--xl-radius-md);
  padding: 12px 14px;
}
.xl-audit__label {
  font-size: 10px; text-transform: uppercase; letter-spacing: 0.06em;
  color: var(--xl-color-text-muted); font-weight: 600;
  margin-bottom: 4px;
}
.xl-audit__value {
  font-family: var(--xl-font-mono);
  font-size: 13px;
  color: var(--xl-color-text);
  word-break: break-all;
}
`;

function fmt(v) {
  if (v === null || v === undefined || v === '') return '\u2014';
  return String(v);
}

function fmtDate(v) {
  if (!v) return '\u2014';
  try { return new Date(v).toLocaleString('es-CO'); }
  catch (_) { return String(v); }
}

export default function AuditoriaCotizacionTabXL({ form }) {
  useEffect(() => { ensureKeyframes(); injectCSS(CSS_ID, CSS); }, []);

  const rows = [
    { label: 'Numero', value: fmt(form.numero) },
    { label: 'Estado', value: fmt(form.estado) },
    { label: 'Creado por (user_id)', value: fmt(form.usuario_creacion) },
    { label: 'Creado', value: fmtDate(form.created_at) },
    { label: 'Ultima actualizacion', value: fmtDate(form.updated_at) },
    { label: 'Venta generada (id)', value: fmt(form.venta_id) },
    { label: 'Cotizacion id', value: fmt(form.id) },
  ];

  return (
    <div className="xl-audit">
      {rows.map((r) => (
        <div key={r.label} className="xl-audit__card">
          <div className="xl-audit__label">{r.label}</div>
          <div className="xl-audit__value">{r.value}</div>
        </div>
      ))}
    </div>
  );
}
